var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b6ih6nkgoa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.458824 0 0 0 0 0.482353 0 0 0 0 0.513725 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-873 -28)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.864 14.32h-.813l-.288-.277c1.009-1.173 1.616-2.697 1.616-4.353C16.38 5.995 13.384 3 9.69 3 5.996 3 3 5.995 3 9.69c0 3.694 2.995 6.69 6.69 6.69 1.656 0 3.18-.608 4.353-1.617l.278.288v.813L19.467 21 21 19.467l-5.136-5.146zm-6.174 0c-2.563 0-4.632-2.068-4.632-4.63 0-2.563 2.069-4.632 4.632-4.632 2.562 0 4.63 2.069 4.63 4.632 0 2.562-2.068 4.63-4.63 4.63z",
    transform: "translate(873 28)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSearch);
export default __webpack_public_path__ + "static/media/icons-search.355b6e26e69df5b170f5fd3894eed9b6.svg";
export { ForwardRef as ReactComponent };